import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { dataFetched, makesQueries } from 'data/graphql'

const AvailablePlansQuery = gql`
  query AvailablePlans {
    listAvailablePlans {
      __typename
      id
      name
      isFree
      amount
      monthlyPricePerUser
      displayOrder
      discountPercentage
      interval
      altIntervalId
      product
    }
  }
`

const providesAvailablePlans = compose(
  connect(
    null,
    { dataFetched }
  ),
  makesQueries({
    query: AvailablePlansQuery,
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(result.data.listAvailablePlans, meta)
    },
  })
)

export default providesAvailablePlans
